import * as React from 'react';
import { useIntl } from 'react-intl';
import ConfirmDialog from '../../ConfirmDialog';
import PermissionsService from '../../../Services/PermissionsService';
import { TPeriodLockRecords } from '../interfaces';
import useAnalytics from '../../../hooks/useAnalytics';
import { getTableName } from '../../CmdTable/CmdTableService';

interface SimpleIconActionProps<T extends TPeriodLockRecords> {
  data: T;
  // icon: string | string[];
  tableName: string;
  onClick?: (data: T) => void;
  // tooltip?: string;
  isConfirmDialog?: boolean;
}

export default function MultiIconAction<T extends TPeriodLockRecords>(
  props: SimpleIconActionProps<T>
) {
  const { formatMessage: f } = useIntl();
  const [isButtonClicked, setIsButtonClicked] = React.useState(false);
  const { trackEvent } = useAnalytics();

  const handlePermission = (): boolean => {
    return PermissionsService.hasAccess(
      props.tableName,
      ['update'],
      props.data.customer.id || null
    );
  };

  const handleData = () => {
    if (props.onClick) {
      props.onClick(props.data);
    }
    if (props.isConfirmDialog) {
      setIsButtonClicked(false);
    }
  };

  const handleOnClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackEvent([`table ${getTableName(props.tableName)}`, 'click', 'Select action']);
    if (props.isConfirmDialog) {
      setIsButtonClicked(true);
    } else {
      handleData();
    }
  };

  const handleCancel = () => {
    trackEvent([`table ${getTableName(props.tableName)}`, 'click', 'Cancel action']);
    setIsButtonClicked(false);
  };

  const handleIconByTable = () => {
    switch (props.data.status) {
      case 'current':
        return 'cmd-icon cmd-icon-edit-lock-date fs-4';
      case 'locked':
        return 'cmd-icon cmd-icon-unlock fs-4 text-turn-on';
      case 'unlocked':
        return 'cmd-icon cmd-icon-lock fs-4 text-turn-off';
      default:
        return 'cmd-icon cmd-icon-edit-lock-date fs-4';
    }
  };

  const handleTooltipByAction = () => {
    switch (props.data.status) {
      case 'current':
        return f({
          id: 'table_list.columns.periodLocks.action_edit_lockAfter',
        });
      case 'locked':
        return f({
          id: 'table_list.columns.periodLocks.action_status_unlock',
        });
      case 'unlocked':
        return f({
          id: 'table_list.columns.periodLocks.action_status_lock',
        });
      default:
        return f({
          id: 'table_list.columns.periodLocks.action_edit_lockAfter',
        });
    }
  };

  return (
    <div style={{ margin: 'auto' }}>
      {isButtonClicked && (
        <ConfirmDialog
          title={f({
            id: 'table.confirm.dialog.remove.title',
          })}
          cancelCallback={handleCancel}
          continueCallback={handleData}
          cancelButtonTitle={f({
            id: 'form.cancel',
          })}
          continueButtonTitle={f({
            id: 'table.deleteBtn',
          })}
        >
          {f({ id: 'table.confirm.dialog.remove.message' })}
        </ConfirmDialog>
      )}
      <a
        href="#"
        title={handleTooltipByAction()}
        data-cy={`table-filter-action_${props.data.status}`}
        className="cmd-table-text-gray"
        data-type="detail"
        data-id="27"
        style={{ padding: '10px 25px', margin: '-10px -25px' }}
        onClick={handlePermission() ? handleOnClick : undefined}
      >
        <i className={handleIconByTable()} style={handlePermission() ? {} : { color: '#ccc' }} />
        <span className="sr-only">{handleTooltipByAction()}</span>
      </a>
    </div>
  );
}
